module.exports = __webpack_public_path__ + "static/media/logo-reina.ffacc140.png";